export class AuthenticationResult {
    constructor(
        public readonly success: boolean,
        public readonly cryptId: string,
        public readonly deniedRole?: boolean,
        public readonly skalSkifteKodeord?: boolean
    ) {}
}
